import {
  UPDATE_USER_INFO,
  CLEAR_USER_INFO,
  CLEAR_USERS,
  SET_FORCED_LOGOUT,
  PARTIAL_LOGIN,
} from './actiontypes';
import { logout } from '../../api/Api';
import { AUTH_LEVELS } from '../constants/roles';
import { clearLoginCookie } from '../../api/loginCookie';
import { deleteAllPointsAction } from './points';
import { deleteAllDevicesAction } from './devices';
import { deleteAllEquipmentAction } from './equipment';
import { deleteAllBuildingsAction } from './buildings';
import { deleteAllDeploymentsAction } from './deployments';
import { deleteAllStagingAction } from './staging';
import { deleteAllDataAlertsAction } from './dataAlerts';

function parseJwt(jwt) {
  const base64Url = jwt.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
}

// an action that updates user info after a completed login
export function updateUserInfoAction(userInfo, authLevel) {
  const jwtBody = parseJwt(userInfo.token);
  // If google jwt, pull userID from userINfo, else use sub
  const userID = Object.hasOwn(jwtBody, 'aud')
    ? userInfo.user_id
    : Number.parseInt(jwtBody.sub, 10);
  return {
    type: UPDATE_USER_INFO,
    jwt: userInfo.token,
    jwtIssuedAt: jwtBody.iat,
    userName: userInfo.name,
    userFullName: userInfo.full_name,
    orgShortName: userInfo.org_short_name,
    orgId: userInfo.org_id,
    userID,
    userAuthLevel: authLevel ?? jwtBody.auth_level,
    mfaRequired: userInfo.mfa_required,
  };
}

// an action that updates user info after a completed login
export function updateUserOrgAction(newOrg) {
  return (dispatch, getState) => {
    const {
      users: { byId, roles, roleTypes },
      user: { userID },
    } = getState();
    return dispatch({
      type: UPDATE_USER_INFO,
      orgId: newOrg.id,
      orgShortName: newOrg.short_name,
      userAuthLevel: Math.min(
        ...roles
          .filter(
            (r) =>
              (r.org_id === null || r.org_id === newOrg.id) && byId[userID].roles.includes(r.id)
          )
          .flatMap((r) => roleTypes.filter((rt) => rt.id === r.role_type_id).map((rt) => rt.level)),
        AUTH_LEVELS.ALL_USER
      ),
    });
  };
}

// the token we receive after a partial login (MFA required) only allows us
// to access the MFA verification endpoints, so save it separately
export const partialUserLogin = (response) => ({
  type: PARTIAL_LOGIN,
  partialLoginToken: response.access_token,
});

export function setForcedLogoutAction(isForced) {
  return {
    type: SET_FORCED_LOGOUT,
    forcedLogout: isForced,
  };
}

// an action that resets all user info
export function clearUserInfoAction() {
  clearLoginCookie();
  return {
    type: CLEAR_USER_INFO,
  };
}

// an action that resets all users info
function clearUsersAction() {
  return {
    type: CLEAR_USERS,
  };
}

function clearAllDataActionCreator() {
  return (dispatch) => {
    dispatch(deleteAllEquipmentAction());
    dispatch(deleteAllPointsAction());
    dispatch(deleteAllDevicesAction());
    dispatch(deleteAllBuildingsAction());
    dispatch(deleteAllDeploymentsAction());
    dispatch(deleteAllStagingAction());
    dispatch(deleteAllDataAlertsAction());
  };
}

export function logoutUserActionCreator(forced = false) {
  return (dispatch, getState) => {
    const {
      user: { jwt },
    } = getState();
    logout(jwt);
    clearLoginCookie();
    dispatch(setForcedLogoutAction(forced));
    dispatch(clearAllDataActionCreator());
    dispatch(clearUsersAction());
    dispatch(clearUserInfoAction());
  };
}
